/*
 *
 * Prospect constants
 *
 */

export const DEFAULT_ACTION = 'app/Prospect/DEFAULT_ACTION';
